import React, { useEffect, useState } from "react";
import { api_url, titleDescription } from "../../config/Config";
import 'react-responsive-modal/styles.css';
import _fetch from "../../config/api";
import toasted from "../../config/toast";
import { useTranslation } from 'react-i18next';
import { ColorRing } from "react-loader-spinner";

const PartiallyTopup = (props: any) => {
    const { t } = useTranslation();

    useEffect(() => {
        document.title = `${props.pageTitle} | ${titleDescription}`;
    });

    const [username, setUsername] = useState();
    const [amount, setAmount] = useState();
    const [trxPassword, setTRXPassword] = useState('');
    const [timeType, setTimeType] = useState();
    const [btnDisable, setbtnDisable] = useState(false);
    const [tradeFundBalance, setTradeFundBalance] = useState(0);
    const [balance, setBalance] = useState(0);
    const [loading, setLoading] = useState(true);
    const [findedUserName, SetfindedUserName] = useState();

    useEffect(() => {
        getBalance();
    }, []);

    const getBalance = async () => {
        setLoading(true);
        const data = await _fetch(`${api_url}investment/getCompoundFundBalance`, "GET", {}, {});

        if (data?.status === 'success') {
            setLoading(false);
            setBalance(data?.data);
            setTradeFundBalance(data?.totalTradeFund);
        }
    }

    const checkUser = async (user_id: any) => {
        let res = await _fetch(`${api_url}auth/checkUser?user=${user_id}`, "GET", {})
        if (res?.status === "success") {
            SetfindedUserName(res?.data?.name);
        }
    }

    const Deposit = async () => {
        setLoading(true);
        setbtnDisable(true);
        let data = {
            "username": username,
            "amount": Number(amount),
            "trxpassword": Number(trxPassword),
            "months": Number(timeType)
        }

        let res = await _fetch(`${api_url}tradeX/partially-topup`, "POST", data);
        if (res?.status === 'success') {
            toasted.success(res?.message);
            setLoading(false);
            setbtnDisable(false);
            setTimeout(() => {
                window.location.reload();
            }, 2000);
        }
        else {
            toasted.error(res?.message);
            setLoading(false);
            setbtnDisable(false);
        }
    }

    return (
        <>
            <main>
                <div className="buy_section loader_main">
                    {loading &&
                        <div className="spinner_bg">

                            <div className="color_ring">  <ColorRing
                                visible={true}
                                height="80"
                                width="80"

                                ariaLabel="blocks-loading"
                                wrapperStyle={{}}
                                wrapperClass="blocks-wrapper"
                                colors={['#2b3892', '#2b3892', '#2b3892', '#2b3892', '#2b3892']}
                            /></div>

                        </div>
                    }
                    <div className="coustom_container">
                        <div className="buy_top_sec">
                            <h4>
                                {t("Partially Topup")}
                            </h4>
                            <div className="inner_data">
                                <p className="">{t("Trade Fund Balance")} : ${Number(tradeFundBalance)?.toFixed(2)}</p>
                                <p className="">{t("Total Compound Balance")} : ${Number(balance)?.toFixed(2)}</p>
                            </div>
                        </div>
                        <div className="row cards_sec">
                            <div className="col-lg-4 col-md-6 col-sm-6">
                                <div className="card christmas_card mb-4">
                                    <div className="card-body">
                                        <div className="card_bottom_Sec">
                                            <div className="buy-section">
                                                <p className="select_amount">
                                                    <input type="text" placeholder='Enter Username' onChange={(e: any) => { setUsername(e.target.value); checkUser(e.target.value) }} value={username} />
                                                    <span className="text-success">{findedUserName}</span>
                                                </p>
                                                <p className="select_amount">
                                                    <input type="number" placeholder='Enter Amount' onChange={(e: any) => setAmount(e.target.value)} value={amount} />
                                                </p>
                                                <p className="select_amount">
                                                    <input type="number" placeholder='Enter Trx Password' onChange={(e: any) => setTRXPassword(e.target.value)} value={trxPassword} />
                                                </p>
                                                <p className="select_amount">
                                                    <select className="form-control btn-square" onChange={(e: any) => setTimeType(e.target.value)} value={timeType}>
                                                        <option value="">--Select Time Period--</option>
                                                        <option value="12">12 Month</option>
                                                        <option value="24">24 Month</option>
                                                        <option value="36">36 Month</option>
                                                    </select>
                                                </p>
                                                <button className="button_style w-100 mt-3" onClick={() => Deposit()} disabled={btnDisable}>
                                                    {`${t("Submit")}`}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* <div className="table_section">
                            <div className="scrolling_table">
                                <div className="scroll_under">
                                    <Table className="support_table">
                                        <thead>
                                            <tr className="table_heading_row">
                                                <th className="table_heading">{t("#")}</th>
                                                <th className="table_heading">{t("Amount")}</th>
                                                <th className="table_heading">{t("Description")}</th>
                                                <th className="table_heading">{t("Date")}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {TradeHistory?.map((item: any, index: any) => {
                                                // const utcDate = new Date(item?.created_at);
                                                // const istDate = new Date(utcDate.getTime() + 5.5 * 60 * 60 * 1000);
                                                return (
                                                    <>
                                                        <tr className="table_data_row">
                                                            <td className="table_data">{page > 1 ? index + keyCount + 1 : index + 1}</td>
                                                            <td className="table_data">${item?.amount?.toFixed(2)}</td>
                                                            <td className="table_data">{item?.description} </td>
                                                            <td className="table_data">
                                                                <div className="pic_text">{dateFormat(item?.created_at, "dd-mm-yyyy hh:MM:ss TT")}</div>
                                                            </td>
                                                        </tr>
                                                    </>
                                                )
                                            })}

                                        </tbody>
                                    </Table>
                                    {totalRecord > 100 && <ReactPaginate className="pagination__2 " activeClassName="active"
                                        breakLabel="..."
                                        nextLabel=">"
                                        onPageChange={handlePageClick}
                                        pageRangeDisplayed={1}
                                        pageCount={totalRecord / 100}
                                        previousLabel="<"
                                    />}
                                </div>
                            </div>
                        </div> */}
                    </div>
                </div>
            </main>
        </>
    );
};

export default PartiallyTopup;
